import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth";
import { AssignmentCalendar } from "@/components/assignments/AssignmentCalendar";
import { RecurrenceRuleEditor } from "@/components/assignments/RecurrenceRuleEditor";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const Route = createFileRoute("/_authenticated/assignments")({
  component: AssignmentsPage,
  head: () => ({ meta: [{ title: "Assignments — MissionReady" }] }),
});

function AssignmentsPage() {
  const { currentOrg, currentRole } = useAuth();
  const canManage = ["org_owner", "admin", "supervisor"].includes(currentRole ?? "");
  if (!currentOrg) return <div className="p-8 text-sm text-muted-foreground">Select an organization.</div>;
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-8">
      <h1 className="mb-1 text-3xl font-semibold tracking-tight">Patrol Assignments</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Schedule patrols, detect conflicts, and surface coverage gaps across your sites.
      </p>
      <Tabs defaultValue="calendar" className="w-full">
        <TabsList>
          <TabsTrigger value="calendar">Calendar</TabsTrigger>
          <TabsTrigger value="recurrence">Recurring rules</TabsTrigger>
        </TabsList>
        <TabsContent value="calendar" className="mt-4">
          <AssignmentCalendar organizationId={currentOrg.id} canManage={canManage} />
        </TabsContent>
        <TabsContent value="recurrence" className="mt-4">
          <RecurrenceRuleEditor organizationId={currentOrg.id} canManage={canManage} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
